module.exports = __webpack_public_path__ + "img/phones.6bc484fd.png";